import type { CaptureContext } from '@sentry/core';

export const captureException = (error: Error | unknown, captureContext?: CaptureContext) => {
  if ($sentry?.captureException) {
    // @ts-ignore
    return $sentry.captureException(error, captureContext);
  }
  console.error(error);

  return 'event-id';
};

export const captureMessage = (error: string, captureContext?: CaptureContext) => {
  if ($sentry?.captureMessage) {
    // @ts-ignore
    return $sentry.captureMessage(error, captureContext);
  }
  // eslint-disable-next-line no-console
  console.log(error);

  return 'event-id';
};
